export default __webpack_public_path__ + "static/media/family.2422e6e7.svg";